import React from "react";

import { mapToTreeData } from "@src/features/table_filtering/utils/filter_utils";
import { FilterPanel } from "@src/types";
import { Collapse, CollapseProps, Tree } from "antd";

import "./filter_collapse.less";

interface FilterCollapseProps {
  filterPanels: FilterPanel[];
  disabled?: boolean;
  onFilter: (filterName: string, values: string[]) => void;
}

const FilterCollapse: React.FC<FilterCollapseProps> = ({
  filterPanels,
  disabled = false,
  onFilter,
}) => {
  const panels: CollapseProps["items"] = filterPanels.map(
    (filterPanel: FilterPanel) => {
      return {
        key: filterPanel.key,
        label: filterPanel.header,
        "data-testid": "filter-panel",
        children: (
          <>
            <div className="filter-panel__border"></div>
            {filterPanel.labels.length > 0 ? (
              <Tree
                checkable
                disabled={disabled}
                onCheck={(values: string[]) =>
                  onFilter(filterPanel.filterType, values)
                }
                treeData={mapToTreeData<string>(filterPanel.labels)}
                checkedKeys={filterPanel.checkedLabels || []}
                selectable={false}
                data-testid="filter-tree"
              />
            ) : (
              <label>No data to filter</label>
            )}
          </>
        ),
      };
    }
  );
  return (
    filterPanels?.length > 0 && (
      <Collapse
        defaultActiveKey={filterPanels.map(
          (filterPanel: FilterPanel) => filterPanel.key
        )}
        expandIconPosition="end"
        className="filter-collapse"
        items={panels}
      />
    )
  );
};

export default FilterCollapse;
